// effects/contacts.effects.ts
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiService } from '../../../services';
import {
  NewContactActions,
  ContactsActions,
  UpdateContactActions,
  DeleteContactActions,
} from './contacts.actions';
import { ContactItem } from 'src/app/components/user-dashboard/contacts/models/contacts';

@Injectable()
export class ContactsEffects {
  constructor(
    private actions$: Actions,
    private api: ApiService,
  ) {}

  loadContacts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContactsActions.load),
      mergeMap(() => {
        return this.api.getContacts().pipe(
          map((contacts) => ContactsActions.loadSuccess({ contacts })),
          catchError((error) => of(ContactsActions.loadFailure({ error }))),
        );
      }),
    ),
  );

  createNewContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NewContactActions.create),
      mergeMap(({ createPayload }) => {
        const payload = {
          name: createPayload.name,
          email: createPayload.email,
          title: createPayload.title,
          bio: createPayload.bio,
          avatar: createPayload.avatar,
        };
        return this.api.createContact(payload, createPayload.type).pipe(
          map((response: ContactItem) =>
            NewContactActions.loadSuccess({ contact: response }),
          ),
          catchError((error) => of(NewContactActions.loadFailure({ error }))),
        );
      }),
    ),
  );

  updateContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdateContactActions.update),
      mergeMap(({ itemId, item, contactType }) =>
        this.api.updateContact(itemId, item, contactType).pipe(
          map((response: ContactItem) =>
            UpdateContactActions.updateSuccess({ contact: response }),
          ),
          catchError((error) =>
            of(UpdateContactActions.updateFailure({ error })),
          ),
        ),
      ),
    ),
  );

  deleteContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeleteContactActions.delete),
      mergeMap(({ id, contactType }) =>
        this.api.deleteContact(id, contactType).pipe(
          map(() => DeleteContactActions.deleteSuccess({ id })),
          catchError((error) =>
            of(DeleteContactActions.deleteFailure({ error })),
          ),
        ),
      ),
    ),
  );
}
